(function () {
  function init() {
    var section = document.querySelector('.dl-terms-of-sale');
    if (!section) return;

    var content = section.querySelector('.dl-terms-of-sale__content');
    if (!content) return;

    var headings = Array.from(content.querySelectorAll('.polictText h3, .polictText h4'));
    if (!headings.length) return;

    var slugs = {};
    headings.forEach(function (heading, idx) {
      if (!heading.id) {
        var slug = (heading.textContent || '')
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
          .slice(0, 60) || 'section';
        var unique = slug;
        var n = 2;
        while (slugs[unique]) {
          unique = slug + '-' + n;
          n += 1;
        }
        slugs[unique] = true;
        heading.id = unique;
      }
    });

    var topLevel = headings.filter(function (h) {
      return h.tagName.toLowerCase() === 'h3';
    });

    var tocLists = section.querySelectorAll('[data-toc-target]');
    if (!tocLists.length || !topLevel.length) return;

    function toSentenceCase(text) {
      // Source headings come in as "1. ABOUT THE WEBSITE". Render them as
      // "1. About the website" so the sidebar feels like UI copy, not shouting.
      var trimmed = (text || '').trim();
      // Preserve any leading "1. " / "10) " style prefix verbatim.
      var match = trimmed.match(/^([0-9]+[.)]\s+)?(.*)$/);
      var prefix = match[1] || '';
      var rest = (match[2] || '').toLowerCase();
      if (rest.length === 0) return prefix;
      var cased = rest.charAt(0).toUpperCase() + rest.slice(1);
      // Legal acronyms keep their capitals even in sentence case.
      var acronyms = ['PDPA', 'GDPR', 'EU', 'DNC', 'FAQ', 'SGD'];
      acronyms.forEach(function (acronym) {
        var pattern = new RegExp('\\b' + acronym + '\\b', 'gi');
        cased = cased.replace(pattern, acronym);
      });
      return prefix + cased;
    }

    var fragment = function () {
      var ul = document.createElement('ul');
      ul.className = 'dl-terms-of-sale__toc-list';
      topLevel.forEach(function (heading) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'dl-terms-of-sale__toc-link';
        a.href = '#' + heading.id;
        a.textContent = toSentenceCase(heading.textContent);
        a.dataset.target = heading.id;
        li.appendChild(a);
        ul.appendChild(li);
      });
      return ul;
    };

    tocLists.forEach(function (target) {
      target.innerHTML = '';
      target.appendChild(fragment());
    });

    var allLinks = Array.from(section.querySelectorAll('.dl-terms-of-sale__toc-link'));

    var SCROLL_OFFSET = 80;

    allLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.dataset.target;
        var target = id ? document.getElementById(id) : null;
        if (!target) return;
        event.preventDefault();
        var top = target.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET;
        window.scrollTo({ top: top, behavior: 'smooth' });
        history.replaceState(null, '', '#' + id);
        var details = link.closest('details');
        if (details) details.open = false;
      });
    });

    function setActive(id) {
      allLinks.forEach(function (link) {
        if (link.dataset.target === id) {
          link.classList.add('is-active');
        } else {
          link.classList.remove('is-active');
        }
      });
    }

    function topOfDocument(el) {
      return el.getBoundingClientRect().top + window.scrollY;
    }

    function updateActiveOnScroll() {
      var threshold = window.scrollY + SCROLL_OFFSET + 20;
      var current = topLevel[0];
      for (var i = 0; i < topLevel.length; i += 1) {
        if (topOfDocument(topLevel[i]) <= threshold) {
          current = topLevel[i];
        } else {
          break;
        }
      }
      if (current) setActive(current.id);
    }

    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          updateActiveOnScroll();
          ticking = false;
        });
      },
      { passive: true }
    );

    updateActiveOnScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
